<template>
  <v-layout row wrap class="c dashboard-metrics-overview">
    <v-flex xs12 md3>
      <absolute-workload
        :workload="workload"
        :max-val="maxVal"
        label="Parkplätze belegt">
      </absolute-workload>
    </v-flex>
    <v-flex xs12 md3>
      <stream :data="streamData"></stream>
    </v-flex>
    <v-flex xs12 md6>
      <line-chart :datasets="lineChart.datasets" :labels="lineChart.labels" data-label="Auslastung in %" @load="onChartLoaded"></line-chart>
    </v-flex>
  </v-layout>
</template>

<script>
import AbsoluteWorkload from './AbsoluteWorkload.vue';
import Stream from './Stream.vue';
import LineChart from '../Metrics/LineChart.vue';

export default {
  name: 'metrics-overview',

  components: {
    AbsoluteWorkload,
    Stream,
    LineChart,
  },

  props: {
    workload: {
      type: Number,
      required: true,
    },
    maxVal: {
      type: Number,
      required: true,
    },
    streamData: {
      type: Array,
      required: true,
    },
    lineChart: {
      type: Object,
      required: true,
    },
  },

  methods: {
    onChartLoaded() {
      this.$emit('load');
    },
  },
};
</script>
